import { render, staticRenderFns } from "./ModalInserirAprovador.vue?vue&type=template&id=ea2ea6a4"
import script from "./ModalInserirAprovador.vue?vue&type=script&lang=js"
export * from "./ModalInserirAprovador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports